// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/b8e410801dc9f1a24986.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3281d554920efbf89d75","159":"192c55b00365f3c8ed5c","160":"8495180846850007da42"}[chunkId] + ".chunk.js";
};